import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { switchMap, takeUntil } from 'rxjs/operators';
import { isEmptyEncounterId, currentEncounterId } from '@mona/pdms/data-access-combined';
import { isSameEncounterFilter } from '@mona/shared/utils';
import { makeDefaultAsyncActionEffect } from '@mona/store';
import { AllergiesState } from '../../entities';
import { AllergiesApi } from '../../infrastructure';
import { AllergiesAction } from '../actions';

/**
 * Allergies effects
 */
@Injectable()
export class AllergiesEffects {
    /* Effect Declarations */

    /**
     * Load allergies effect
     */

    loadAllergies$ = createEffect(() =>
        this.actions$.pipe(
            ofType(AllergiesAction.loadAllergiesAction.action),
            switchMap(action =>
                makeDefaultAsyncActionEffect(
                    this.allergiesApi
                        .getAllergies(action.encounterId)
                        .pipe(
                            isSameEncounterFilter(currentEncounterId(this.store), action.encounterId),
                            takeUntil(isEmptyEncounterId(this.store)),
                        ),
                    AllergiesAction.loadAllergiesAction,
                ),
            ),
        ),
    );

    /**
     * Constructor
     *
     * @param actions$ Actions
     * @param allergiesApi AllergiesApi
     * @param store Store<AllergiesState>
     */
    constructor(private actions$: Actions, private allergiesApi: AllergiesApi, private store: Store<AllergiesState>) {}
}
